import { Component, Input, SimpleChanges } from '@angular/core';
import { OfbizList, RemoteFormData, ColumnFieldTitle, OfbizField } from '@urbannex/ofbiz-forms';
import { getFields, getColumnFieldTitles } from '@urbannex/view-containers';
import { PART_FORMS } from '../../../forms';

@Component({
  selector: 'pty-customer-identification',
  templateUrl: './customer-identification.component.html',
  styleUrls: ['./customer-identification.component.scss']
})
export class CustomerIdentificationComponent {
  @Input() partyId:string;
  listForm:OfbizList;
  
  title:"Credit Card";
  fieldOptions:any;
  state$:any;
  isLookup:false;
  cardMode:true;
  remoteFormData:RemoteFormData;
  columnFieldTitles:ColumnFieldTitle[];
  columnFields:OfbizField[];
  listOptions:any;
  hasRemoteData = false;

  constructor(){}

  ngOnChanges(changes: SimpleChanges): void {
    if(changes["partyId"]){
      this.listForm = new OfbizList({
        listFormName:"ListPartyIdentification",
        listFormLocation:"component://kwikstore/widget/PartyForms.xml",
        columnFields:getFields("ListPartyIdentification",PART_FORMS),
        columnFieldTitles:getColumnFieldTitles("ListPartyIdentification",PART_FORMS),
        //fieldFormFields:any,
        listType:"grid",
        emptyListMessage:"No Postal Addresses found for this customer",
        remoteFormData:{
          formData:{
            formName:"ListPartyIdentification",
            formLocation:"component://kwikstore/widget/PartyForms.xml",
            viewIndex:0,
            listType:"grid",
          },
          parameters:{"partyId":this.partyId,"paymentMethodTypeId":"EFT_ACCOUNT"},
          endPoint:"partymgr"
        }
      })
      this.remoteFormData = {
        formData:{
          formName:"ListPartyIdentification",
          formLocation:"component://kwikstore/widget/PartyForms.xml",
          viewIndex:0,
          listType:"grid",
        },
        parameters:{"partyId":this.partyId,"paymentMethodTypeId":"EFT_ACCOUNT"},
        endPoint:"partymgr"
      };
      this.columnFields = getFields("ListPartyIdentification",PART_FORMS),
      this.columnFieldTitles = getColumnFieldTitles("ListPartyIdentification",PART_FORMS),
      this.state$.remoteFormData = this.remoteFormData;
      this.hasRemoteData = true;
      console.log(this.remoteFormData);
    }
  }
}
